import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeCaseToWords',
})
export class SnakeCaseToWordsPipe implements PipeTransform {
  transform(value: string): string {
    return value.replaceAll('_', ' ');
  }
}
